import { Box, Button, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Order, OrderItem } from '../Models/Orders';
import { ApiGetOrders } from '../Core/Apicall';
import { toast } from 'react-toastify';
import { VariantImage } from '../Models/Varient';
import { Cancel, CancelOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function MyOrders() {
    const [orderlist, setOrderList] = useState<Order[]>()
    const [selectedOrder, setSelectedOrder] = useState<Order | null>()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
    const navigate = useNavigate();

    const getOrder = async () => {
        try {
            const res = await ApiGetOrders()
            if (res?.success) {
                setOrderList(res?.data)
                !isMobile && setSelectedOrder(res?.data[0])
            }
        } catch (error: any) {
            toast.error(error?.message || "Soemthing went worng")
        }
    }

    useEffect(() => {
        getOrder()
    }, [])

    const handleToggle = (id: number) => {
        if (isMobile) {
            navigate(`/orders/${id}`);
            return;
        }

        if (selectedOrder?.orderId === id) return;
        setSelectedOrder(orderlist?.find((item) => item.orderId === id));
    };


    return (
        <Box className='p-3 p-md-5 w-100' sx={{ height: 'calc(100vh - 80px)' }}>
            <Grid container spacing={2} className='h-100'>
                <Grid size={{ xs: 12, lg: 'grow' }} className='p-2 h-100'>
                    <Typography className='fs-24 text-white fw-bold'>My Orders</Typography>
                    <Typography className='fs-16 text-grey fw-bold mb-4'>Track, view and manage all your orders in one place.</Typography>
                    <Grid container spacing={1}>
                        {orderlist?.map((order: Order) => {
                            return (
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Grid container className={`bg-grey ${selectedOrder?.orderId === order?.orderId ? "border-yellow" : ""} border-10 p-3 px-md-4`}>
                                        <Grid size={{ xs: 6, md: 7 }}>
                                            <Grid container>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Box className='mb-3'>
                                                        <Typography className='fs-14 text-white'>Order ID</Typography>
                                                        <Typography className='fs-16 text-white fw-semibold'>{order?.order_number}</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography className='fs-14 text-white'>Placed on</Typography>
                                                        <Typography className='fs-16 text-white fw-semibold'>{new Date(order?.created_at).toLocaleDateString('en-US', {
                                                            month: 'short',
                                                            day: 'numeric',
                                                            year: 'numeric',
                                                        })}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid className='border-right-light-main' size={{ xs: 12, md: 6 }}>
                                                    <Box className='mb-3'>
                                                        <Typography className='fs-14 text-white'>Items</Typography>
                                                        <Typography className='fs-16 text-white fw-semibold'>{order.items.length} Items</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography className='fs-14 text-white'>Total Amount</Typography>
                                                        <Typography className='fs-16 text-white fw-semibold'>${order.total_amount}</Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ xs: 6, md: 5 }} className='ps-3'>
                                            <Grid container spacing={2}>
                                                <Grid size={{ xs: 12, md: 5.5 }}>
                                                    <Box className='mb-3'>
                                                        <Typography className='fs-14 text-white'>Status</Typography>
                                                        <Typography className='fs-14 px-2  py-1 fw-semibold btn-light-yellow' style={{ width: 'fit-content' }}>{order?.order_status}</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography className='fs-14 text-white'>Delivered on</Typography>
                                                        <Typography className='fs-16 text-white fw-semibold'>{new Date(order.created_at).toLocaleDateString('en-US', {
                                                            month: 'short',
                                                            day: 'numeric',
                                                            year: 'numeric',
                                                        })}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6.5 }}>
                                                    <Box className='mb-3'>
                                                        <Button onClick={() => { handleToggle(order?.orderId) }} className='border-main border-10 text-white p-0 py-1 px-2'>View Details</Button>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
                {selectedOrder && !isMobile && (
                    <Grid size={{ xs: 12, lg: 3 }} className='border-main border-10  h-100'>
                        <Box className='bg-grey text-white d-flex align-items-centers justify-content-between w-100 p-3 fs-18 fw-bold'>
                            <Typography className='text-white fs-18 fw-bold'> Order Details</Typography>
                            <IconButton className='m-0 p-0' onClick={() => { setSelectedOrder(null) }}><CancelOutlined className='text-white' /></IconButton>
                        </Box>
                        <Box className='mt-3 p-2 px-3'>
                            <Box className='mb-2 d-flex align-items-start gap-3'>
                                <Box>
                                    <Typography className='fs-14 text-grey'>Order ID</Typography>
                                    <Typography className='fs-14 text-white'>{selectedOrder?.order_number}</Typography>
                                </Box>
                                <Typography className='fs-14 px-2  py-1 fw-semibold btn-light-yellow' style={{ width: 'fit-content' }}>{selectedOrder?.order_status}</Typography>
                            </Box>
                            <Box>
                                <Typography className='fs-14 text-grey'>Placed on</Typography>
                                <Typography className='fs-14 text-white'>{new Date(selectedOrder?.created_at).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric',
                                })}</Typography>
                            </Box>

                            <Box className='mt-3'>
                                <Typography className='fw-bold fs-16 text-white' gutterBottom>Shipping Address</Typography>
                                <Typography className='fs-14 text-white'>{selectedOrder?.shipping_address?.address_line_1}, {selectedOrder?.shipping_address?.address_line_2}, {selectedOrder?.shipping_address?.city}, {selectedOrder?.shipping_address?.state} - {selectedOrder?.shipping_address?.postal_code}</Typography>
                                <Typography className='fs-14 text-white' gutterBottom>{selectedOrder?.shipping_address?.country}</Typography>
                                <Typography className='fs-14 text-white' gutterBottom>{selectedOrder?.shipping_address?.mobile_number}</Typography>
                            </Box>

                            <hr className='border-main' />
                            <Box className='d-flex align-items-start justify-content-between'>
                                <Box>
                                    <Typography className='fs-16 fw-bold text-white' gutterBottom>Payment Method</Typography>
                                    <Typography className='text-white fs-14'>**** **** **** 4242</Typography>
                                    <Typography className='fs-12 text-grey'>paid via Credit Card</Typography>
                                </Box>
                                <Typography className='fs-18 fw-bold text-white'>${selectedOrder?.total_amount}</Typography>
                            </Box>

                            <hr className='border-main' />
                            <Box className='mb-2'>
                                <Typography className='fs-16 fw-bold text-white' gutterBottom>Order Items ({selectedOrder?.items?.length})</Typography>
                                {selectedOrder?.items?.map((item) => (
                                    <Box className='d-flex align-items-center gap-3 mb-2'>
                                        <Box component={'img'} height={'50px'} width={'50px'} className='border-10' src={item?.variant?.variantImages?.find((item: VariantImage) => item?.is_thumbnail == true)?.image_url || item?.variant?.variantImages[0].image_url} />
                                        <Box className='d-flex align-items-center justify-content-between flex-1'>
                                            <Typography className='text-white fs-14'>{item?.variant?.name}</Typography>
                                            <Typography className='fs-12 text-grey'>Qty: <span className='text-white'>{item?.quantity}</span></Typography>
                                            <Typography className='fs-14 fw-bold text-white'>${item?.total_price}</Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                            <hr className='border-main' />
                            <Box>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Typography className='text-white fs-14'>Subtotal ({selectedOrder?.items?.length} items)</Typography>
                                    <Typography className='text-white fs-16'>${selectedOrder?.subtotal}</Typography>
                                </Box>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Typography className='text-white fs-14'>Tax(5%)</Typography>
                                    <Typography className='text-white fs-16'>${selectedOrder?.tax_amount}</Typography>
                                </Box>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Typography className='text-white fs-14'>Discount</Typography>
                                    <Typography className='text-white fs-16'>${selectedOrder?.discount_amount}</Typography>
                                </Box>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Typography className='text-white fs-14'>Delivery Fee</Typography>
                                    <Typography className='text-white fs-16'>${selectedOrder?.shipping_amount}</Typography>
                                </Box>
                                <hr className='border-main' />
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Typography className='text-white fs-18 fw-bold'>Total</Typography>
                                    <Typography className='text-white fs-20'>${selectedOrder?.total_amount}</Typography>
                                </Box>
                            </Box>

                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}

export default MyOrders
